import types from 'redux/types';
import { checkTypeValue } from 'helpers';
import {
  baseNotification,
  fetchNotification,
  fetchNotificationSuccess,
  fetchNotificationFailed,
  fetchCountNotificationFailed,
  fetchCountNotificationSuccess,
  fetchLoadMoreNotification,
  fetchLoadMoreNotificationSuccess,
  fetchLoadMoreNotificationFailed,
  fetchMarkAllAsRead,
  fetchMarkAllAsReadSuccess,
  fetchMarkAllAsReadFailed,
  fetchMarkAsRead,
  fetchMarkAsReadSuccess,
  fetchMarkAsReadFailed,
} from 'redux/handleReducers';
import components, { typeUnmounted } from 'consts/components';

const initialState = {
  ...baseNotification(),
};

export default (state, actions) => {
  if (checkTypeValue(state, 'undefined')) {
    return initialState;
  }
  switch (actions.type) {
    case types.CHANGE_FILTER_NOTIFICATION:
      return {
        ...state,
        isGettingMore: true,
      };

    case types.REQUEST_GET_MORE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isGettingMore: false,
        notifications: actions.notifications,
        isLast: actions.isLast,
      };

    case types.REQUEST_GET_NOTIFICATION:
      return fetchNotification(actions, state);

    case types.REQUEST_GET_NOTIFICATION_SUCCESS:
      return fetchNotificationSuccess(actions, state);

    case types.REQUEST_GET_NOTIFICATION_FAILED:
      return fetchNotificationFailed(actions, state);

    case types.REQUEST_COUNT_NOTIFICATION_SUCCESS:
      return fetchCountNotificationSuccess(actions, state);

    case types.REQUEST_COUNT_NOTIFICATION_FAILED:
      return fetchCountNotificationFailed(actions, state);

    case types.REQUEST_LOAD_MORE_NOTIFICATION:
      return fetchLoadMoreNotification(actions, state);

    case types.REQUEST_LOAD_MORE_NOTIFICATION_SUCCESS:
      return fetchLoadMoreNotificationSuccess(actions, state);

    case types.REQUEST_LOAD_MORE_NOTIFICATION_FAILED:
      return fetchLoadMoreNotificationFailed(actions, state);

    case types.REQUEST_MARK_AS_ALL_READ:
      return fetchMarkAllAsRead(actions, state);

    case types.REQUEST_MARK_AS_ALL_READ_SUCCESS:
      return fetchMarkAllAsReadSuccess(actions, state);

    case types.REQUEST_MARK_AS_ALL_READ_FAILED:
      return fetchMarkAllAsReadFailed(actions, state);

    case types.REQUEST_UPDATE_NOTIFICATION:
      return fetchMarkAsRead(actions, state);

    case types.REQUEST_UPDATE_NOTIFICATION_SUCCESS:
      return fetchMarkAsReadSuccess(actions, state);

    case types.REQUEST_UPDATE_NOTIFICATION_FAILED:
      return fetchMarkAsReadFailed(actions, state);

    case typeUnmounted(components.notifications):
      return initialState;

    default:
      return state;
  }
};
